<template>
  <div v-if="$bp.isMdOrLess && isTimelineOpen"
       class="timeline-images hide-scrollbar"
       :class="{'square-mode': !isMosaicModeActive}"
  >
    <item-gallery-list-item v-for="image in images"
                            :key="image.id"
                            :image="image"
    />
  </div>
</template>

<script>
import ItemGalleryListItem from "@/components/pages/ItemGallery/ItemGalleryContent/ItemGalleryListItem";
import { mapState, mapGetters } from "vuex";

export default {
  name: "TimelineImages",
  components: {
    ItemGalleryListItem
  },
  computed: {
    ...mapState('Interface', ['isTimelineOpen']),
    ...mapState('Settings', ['isMosaicModeActive']),
    ...mapGetters('Coordinates', ['images'])
  }
}
</script>

<style lang="scss">
.timeline-images {
  display: none;
  overflow: auto;
  height: fit-content;
  max-height: 100%;
  z-index: 1;
  padding-bottom: calc($mobile-navigator-item-size + calc($content-padding-bottom * 2));

  .item-gallery__content__list__item-container {
    &:last-child {
      padding-bottom: 0;
    }
  }

  &.square-mode .item-gallery__content__list__item-container {
    height: 180px;
  }

}

@include smallerThan("md") {
  .timeline-images {
    display: grid;
    grid-template-columns: 100%;
  }
}
</style>